import React from "react";
import { motion } from "framer-motion";

function SectionHeading({ eyebrow, title, subtitle, light = false, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className={`text-center max-w-3xl mx-auto mb-10 sm:mb-14 px-4 ${className}`}
    >
      {eyebrow && (
        <span
          className={`inline-block text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] mb-3 ${
            light ? "text-brand-yellow" : "text-brand-navy-light"
          }`}
        >
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-display font-bold text-3xl sm:text-4xl md:text-5xl leading-tight ${
          light ? "text-white" : "text-brand-navy"
        }`}
      >
        {title}
      </h2>
      <div className="mt-5 mx-auto h-1 w-16 rounded-full bg-brand-yellow" />
      {subtitle && (
        <p className={`mt-5 text-base sm:text-lg ${light ? "text-blue-100" : "text-gray-600"}`}>
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}

export default SectionHeading;
